import { put, takeEvery } from 'redux-saga/effects';

import { routines as modalRoutines } from '../../reducers/ui/modal';

function* closeAndOpen({ payload }) {
  yield put(modalRoutines.closeModal.trigger());
  yield put(modalRoutines.openModal.trigger(payload));
}

export default function* modalSaga() {
  yield takeEvery(modalRoutines.closeAndOpenModal.TRIGGER, closeAndOpen);
}
